import { useCallback, useEffect, useRef, useState } from "react";

export const useTableAutoHeight = (deps = []) => {
  const tableContainerRef = useRef(null);
  const [tableContainerNode, setTableContainerNode] = useState(null);
  const [tableHeight, setTableHeight] = useState(300);
  const [headerHeight, setHeaderHeight] = useState(50);
  const debounceTimerRef = useRef(null);
  const animationFrameRef = useRef(null);

  const setTableContainerRef = useCallback((node) => {
    tableContainerRef.current = node;
    setTableContainerNode(node);
  }, []);

  useEffect(() => {
    if (!tableContainerNode) return;

    const computeHeaderHeight = () => {
      let height = 0;
      const actions = tableContainerNode.querySelector(".table-actions");
      if (actions) {
        height += actions.offsetHeight + 5;
      }
      const thead = tableContainerNode.querySelector(".ant-table-thead");
      if (thead) {
        height += thead.offsetHeight;
      }
      setHeaderHeight(height);
    };

    const handleResize = () => {
      // Дебаунс ResizeObserver
      clearTimeout(debounceTimerRef.current);
      debounceTimerRef.current = setTimeout(() => {
        if (animationFrameRef.current) {
          cancelAnimationFrame(animationFrameRef.current);
        }
        animationFrameRef.current = requestAnimationFrame(() => {
          setTableHeight(tableContainerNode.offsetHeight || 0);
          computeHeaderHeight();
        });
      }, 50); // 50ms дебаунс
    };

    const resizeObserver = new window.ResizeObserver(handleResize);
    resizeObserver.observe(tableContainerNode);
    handleResize(); // Начальная высота

    // Начальный замер с задержкой
    const theadTimer = setTimeout(computeHeaderHeight, 100);

    // Наблюдатели за изменениями размеров thead и actions
    const headerResizeObserver = new window.ResizeObserver(() => {
      computeHeaderHeight();
    });

    const actionsEl = tableContainerNode.querySelector(".table-actions");
    const theadEl = tableContainerNode.querySelector(".ant-table-thead");

    if (actionsEl) headerResizeObserver.observe(actionsEl);
    if (theadEl) headerResizeObserver.observe(theadEl);

    return () => {
      resizeObserver.disconnect();
      headerResizeObserver.disconnect();
      clearTimeout(theadTimer);
      clearTimeout(debounceTimerRef.current);
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
    // eslint-disable-next-line
  }, [tableContainerNode, ...deps]);

  return { tableContainerRef: setTableContainerRef, tableHeight, headerHeight };
};
